import { createContractRequest } from './helper';
export const postParticipantRoles = createContractRequest({
    route: '/contract/offers/:offerId/participantRoles',
    method: 'post',
    source: 'data',
});
